<template>
	<div class="fc-global-login" @touchmove.prevent>
		<div>
			<div class="fc-login-form">
				<h5>Welcome, kindly login to proceed</h5>
				<form>
					<div>
						<label><span>*</span>EMAIL ADDRESS</label>
						<input v-model="username" type="text" />
					</div>
					<div>
						<label><span>*</span>PASSWORD</label>
						<input v-model="password" type="password" />
					</div>
					<div>
						<a @click="forgotpassword">Forgot password?</a>
					</div>
					<a @click="login">LOGIN</a>
				</form>
				<div class="fc-register">
					<h5>I'm new</h5>
					<a @click="register">REGISTER</a>
				</div>
				<div class="fc-login-third">
					<facebook-login class="button"
			      appId="445932519566099"
			      loginLabel="Continue with Facebook"
			      @login="loginWithFB"
			      @sdk-loaded="fbLoaded">
			      <a class="fc-login-facebook">Continue with Facebook</a>
			    </facebook-login>
			    <g-signin-button
				    :params="googleSignInParams"
				    @success="onSignInSuccess"
				    @error="onSignInError">
				    <a class="fc-login-google">Continue with Google</a>
				  </g-signin-button>
				</div>
			</div>
			<div>
				<i class="icon-img-subway-login fc-mobile-hide"></i>
				<i class="icon-img-subway-login2 fc-mobile-show"></i>
			</div>
			<div class="fc-global-login_close" @click="close"></div>
		</div>
	</div>
</template>
<script>
import facebookLogin from 'facebook-login-vuejs'
import $ from 'jquery'
export default {
  name: 'user-login',
  components: {
    facebookLogin
  },
  data () {
    return {
      username: '',
      password: '',
      FB: undefined,
      googleSignInParams: {
        client_id: '926155119395-v9n8h468qje8bp49b9rkd405r084fck5.apps.googleusercontent.com'
      }
    }
  },
  methods: {
    login: function () {
      if (this.username === '' || this.password === '') {
        if (process.browser) {
          $.alert({
            title: 'Notice',
            content: 'Please input your email or password',
            type: 'orange',
            useBootstrap: false
          })
        }
        return
      }
      const params = {
        Email: this.username,
        Password: this.password
      }
      this.$store.dispatch('profileLogin/login', params)
        .then(a => {
          this.$emit('closelogin')
          if (this.$route.path === this.RouterConfig.ForgotPassword) {
            this.$router.push(this.RouterConfig.Home)
          }
        })
        .catch(() => {
        })
    },
    register: function () {
      this.$emit('closelogin')
      this.$router.push({path: this.RouterConfig.Register})
    },
    forgotpassword () {
      this.$emit('closelogin')
      this.$router.push({path: this.RouterConfig.ForgotPassword})
    },
    close: function () {
      this.$emit('closelogin')
    },
    loginWithFB () {
      this.getFBUser()
    },
    fbLoaded (payload) {
      this.FB = payload.FB
      if (payload.isConnected) {
        this.FB.logout()
      }
    },
    getFBUser () {
      this.FB.api('/me', 'GET', { fields: 'id,name,email' },
        userInformation => {
          const data = {
            OpenId: userInformation.id,
            From: 1,
            Avatar: '',
            Email: userInformation.email,
            Name: userInformation.name
          }
          this.signup(data)
        }
      )
    },
    onSignInSuccess (googleUser) {
      const profile = googleUser.getBasicProfile()
      const data = {
        OpenId: profile.getId(),
        From: 2,
        Avatar: profile.getImageUrl(),
        Email: profile.getEmail(),
        Name: profile.getName()
      }
      this.signup(data)
    },
    onSignInError () {
    },
    signup (data) {
      this.$store.dispatch('profileLogin/signup', data)
        .then(a => {
          this.$emit('closelogin')
          if (this.$route.path === this.RouterConfig.ForgotPassword) {
            this.$router.push(this.RouterConfig.Home)
          }
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Login.vue